<div class="layout flex flex-col">
  <tr-header></tr-header>
  <main class="flex flex-1 items-stretch">
    <tr-main-menu></tr-main-menu>
    <div class="content-body flex-1">
      <section class="container p-4 pb-5 mx-auto">
        <router-outlet></router-outlet>
      </section>
    </div>
  </main>
</div>